// extracted by mini-css-extract-plugin
module.exports = {"colors":"'styles/colors.module.css'","CHARCOAL":"#282828","detailItem":"styles_detailItem__qE21M","checkIcon":"styles_checkIcon__f5Mrm","bold":"styles_bold__g2mLD"};